import { h, Host } from "@stencil/core";
export class PopoverPanelArrow {
    constructor() {
        this.border = true;
    }
    render() {
        const baseClass = "ux-popover-panel-arrow";
        return (h(Host, { key: '60484f30422adc51c8d88c5f85f7dbb0a1da442f' }, this.border && (h("span", { key: 'c4196782427c50805298963ee767f83894980a36', class: {
                [baseClass]: true,
                [`${baseClass}__border`]: true
            } })), h("span", { key: '627052ee0f69fc151c9386b20d90e6699c9dff12', class: {
                [baseClass]: true,
                [`${baseClass}__fill`]: true
            } })));
    }
    static get is() { return "ux-popover-panel-arrow"; }
    static get originalStyleUrls() {
        return {
            "$": ["./popover-panel-arrow.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["popover-panel-arrow.css"]
        };
    }
    static get properties() {
        return {
            "border": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "true",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Indicates that the arrow should render with border"
                },
                "attribute": "border",
                "reflect": true,
                "defaultValue": "true"
            }
        };
    }
}
//# sourceMappingURL=popover-panel-arrow.js.map
